import { Col, Empty, Row, Skeleton, Table } from 'antd';
import { FormInstance } from 'antd/lib/form';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TableConfigurator from '../../shared/components/TableConfigurator/TableConfigurator';
import { GUTTOR_SPACE } from '../../shared/constants/commonConstants';
import { getClaimListTableMapping } from '../../shared/constants/crmConstants';
import { RootState } from '../../store';
import { fetchTodaysClaims, saveInPatientConfig } from '../../store/actions/inPatientAction';
import { fetchInpatientStatusList } from '../../store/actions/lookUpAction';
import { ApplicationDetailModel } from '../../store/models/applicationDetailModel';
import { centeredNotification } from '../../utils/utility';
import { getTableBasedOnConfig } from '../crm/inPatient/service/crmUtils';
const ClaimsList = ({ location: { pathname } }: any): any => {
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const {payerClaimStatuses }: any = useSelector((state: RootState): any => state.lookUp);
  const dispatch = useDispatch();
  const blankArr = Array(10).fill(0);
  const [tableData, setTableData] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.toLocaleString('default', { month: 'short' });
  const year = currentDate.getFullYear();
  const screenHeight = 98 / 100 * (window.innerHeight);
  const estimatedRowHeight = 80;
  const noOfRowsPerPage = Math.floor(screenHeight / estimatedRowHeight);
  const formattedDate = `${day} ${month} ${year}`;
  let isPageGreaterThanOne = false;
  const todayDate = moment();
  const [showFullNames, setShowFullNames] = useState(false);
  const toggleFullNames = (): any => {
    setShowFullNames((prevState: any): any => !prevState);
  };
  const inPatientTableMapping = getClaimListTableMapping(showFullNames, toggleFullNames);
  const inPatientTableMappingForTableConfigurator = getClaimListTableMapping(showFullNames, toggleFullNames, true);
  const filteredTable = getTableBasedOnConfig(appDetail.getClaimsViewConfig(), inPatientTableMapping);
  useEffect((): any => {
    if (payerClaimStatuses.length === 0 || payerClaimStatuses === undefined) {
      dispatch(fetchInpatientStatusList());
    }
    if (currentPage === 1) {
      const validPayerClaimStatuses = payerClaimStatuses?.filter((ele: any): any => ele.key !== '13');
      const validStatusIds = validPayerClaimStatuses.map((ele: any): any => ele.key);
      const startOfDay = todayDate.clone().startOf('day');
      const endOfDay = todayDate.clone().endOf('day');
      const filters = [
      { key: 'dod', value: [startOfDay, endOfDay]},
      { key: 'statusId', value: validStatusIds }];
      const requestPayload = {
        filters,
        payerId: 99999,
        isSearchEnabled: true,
        range: 100,
      };
      dispatch(fetchTodaysClaims({requestPayload, onSuccess, onError }));
    }
    const intervalId = setTimeout((): void => {
      changePage();
    }, 30000);
    return (): void => clearTimeout(intervalId);
  }, [currentPage]);

  const onSuccess = (data: any, claimsCount: any): void => {
    const newArray = data.map((obj: any, index: any): any => {
      return { ...obj, newKey: index + 1 };
    });
    if (claimsCount > 0) {
      setTableData(newArray);
      const totalItems = newArray?.length;
      const totalPages = Math.ceil(totalItems / noOfRowsPerPage);
      if (totalPages > 1) {
        isPageGreaterThanOne = true;
      }
      setCount(totalPages);
    }
  };

  const changePage = (): any => {
    setCurrentPage((prevPage: any): any => {
      if (currentPage === 1) {
        return (!isPageGreaterThanOne || prevPage % count === 0) ? 1 : prevPage + 1;
      } else {
        return prevPage % count === 0 ? 1 : prevPage + 1;
      }
    });
  };
  const onError = (): any => {
    centeredNotification('No claims available');
  };

  const onColumnEditSave = (form: FormInstance, setIsVisible: any): any => {
    dispatch(saveInPatientConfig(form.getFieldsValue(), setIsVisible, 'claimsDisplay'));
  };
  return (
    <React.Fragment>
      <div className="claimListView">
        <div className="claimDiv">
          <Row
            gutter={GUTTOR_SPACE}
            justify="space-between"
            className="claimsDisplay-table-config"
          >
            <Col className="heading-col">
            DISCHARGES DUE TODAY : {formattedDate}
            </Col>
            <Col>
              <TableConfigurator
                tableMapping={inPatientTableMappingForTableConfigurator}
                saveClickHandler={onColumnEditSave}
                configuration={appDetail.getClaimsViewConfig()}
                isClaimsView={true}
              />
            </Col>
          </Row>
          <Table
            data-testid="in-patient-list"
            columns={filteredTable}
            dataSource={tableData}
            pagination={{ pageSize: noOfRowsPerPage, current: currentPage, hideOnSinglePage: true }}
            rowKey={(record: any): any => record.newKey}
            className={'custom-table'}
            locale={{
              emptyText: (
                false ?
                  <div className="full-skelton-in-list">
                    {blankArr.map((...params: any[]): any =>
                      <Skeleton
                        key={params[1]}
                        active={true}
                        paragraph={{ rows: 0 }}
                      />,
                    )}
                  </div>
                  : <Empty />
              ),
            }}
          />

        </div>
        {count ? <div className="table-page-view">Page {currentPage} out of {count} </div> : <></>}

      </div>

    </React.Fragment>
  );
};
export default ClaimsList;
